export default "__VITE_ASSET__CZR$mQx7__"